// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"224":"register","610":"PageInfo","966":"login"}[chunkId] + "." + {"224":"a27ec789","610":"87acdbd1","966":"bf3d3245"}[chunkId] + ".css";
};